import * as z from "zod/v4";
import { ProductTaxonomyItemSchema } from "./get-product-taxonomy";

export const searchProductTaxonomy = {
  name: "searchProductTaxonomy" as const,
  input: z.object({ source: z.string(), query: z.string() }),
  output: z.object({ results: z.array(ProductTaxonomyItemSchema) }),
};
